import { InventoryModel } from "./inventory.model";

export class InventoryReportModel extends InventoryModel {
  KioskToken: string;
  KioskName: string;
  ProductIdName: string;
  Address: string;
  LockerMode: string;
}
